export default "__VITE_ASSET__DnRqRzpA__"